module.exports = __webpack_public_path__ + "img/header_zada.cd0350ca.jpg";